<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-content: center;height: 85vh;">
      <el-card class="cardStyle">
        <div style="width: 100%;display: flex;justify-content: space-between;height:600px">
          <div class="ticketStyle" >
            <el-card style="margin: 30% 5% 30% 5%; height: 60%">
              <div style="display: flex;justify-content: center;flex-wrap: wrap">
                <div style="width: 100%;display: flex;justify-content: center;">
                  <img src="../assets/image/logo.png" style="height: 50px;width: 50px"  alt="">
                </div>
                <div>
                  <span class="fontStyle">朋朋修脚</span>
                </div>
                <div style="width: 100%;text-align: center;">
                  <p class="card_name">{{discountTicket.title}}</p>
                </div>
                <div style="width: 100%;text-align: center;">
                  <p class="cardTips">{{discountTicket.fuTitle}}</p>
                </div>
                <div style="width: 100%;text-align: center;">
                  <el-button style="color: rgb(255, 255, 255); background-color: rgb(44, 159, 103);">
                    立即使用
                  </el-button>
                </div>
                <div>
                  <span class="fontStyle">截止有效期：
									  <span >{{discountTicket.validDate}}</span>
								  </span>
                </div>
              </div>
            </el-card>
          </div>
          <div style="width: 68%;background-color: #eff3f8;">
            <div style="margin-top: 5px;margin-left: 10px">
              <span >优惠券设置</span>
            </div>
            <el-divider class="line"></el-divider>
            <div style="margin-left: 10px;">
              <span style="font-size: 14px">优惠券类型:</span>
              <el-radio-group v-model="discountTicket.ticketType" size="mini" @change="selectTicketType">
                <el-radio v-for="item in ticketTypes"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                  style="margin-top: 10px"
                >
                  {{item.label}}
                </el-radio>
              </el-radio-group>
            </div>
            <div style="margin-left: 10px;margin-top: 10px">
              <span style="font-size: 14px">优惠券标题:</span>
              <el-input v-model="discountTicket.title"  size="mini" style="width: 40%;"></el-input>
            </div>
            <div style="margin-left: 10px;margin-top: 10px">
              <span style="font-size: 14px">优惠副标题:</span>
              <el-input v-model="discountTicket.fuTitle"  size="mini" style="width: 40%;"></el-input>
            </div>
            <div style="margin-left: 10px;margin-top: 10px"
              v-if="discountTicket.ticketType === 1 || discountTicket.ticketType === 4 || discountTicket.ticketType === 6"
            >
              <span style="font-size: 14px">代金券面额:</span>
              <el-input v-model="discountTicket.money" onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @input="setDMoney"
                        size="mini" style="width: 10%;"></el-input>元
              <br>
              <span style="color: #8c939d;margin-left: 10%;font-size: 12px">代金券面额，例如：金额2元，商品原价10元，用户仅需付8元</span>
            </div>
            <div style="margin-left: 10px;margin-top: 10px"
                 v-if="discountTicket.ticketType === 3"
            >
              <span style="font-size: 14px">消费每满:</span>
              <el-input v-model="discountTicket.fullMoney" onkeyup="value=value.replace(/[^\d.]/g,'')"
                        size="mini" style="width: 10%;" @input="setFullMoney"></el-input>元
              <span style="font-size: 14px; margin-left: 5%">立减:</span>
              <el-input v-model="discountTicket.subMoney" onkeyup="value=value.replace(/[^\d.]/g,'')"
                        size="mini" style="width: 10%;" @input="setFullMoney"></el-input>元
              <br>
              <span style="color: #8c939d;margin-left: 10%;font-size: 12px">优惠每满立减。例如：消费每满100元，减20元，消费200元，用户仅需付160元</span>
            </div>
            <div style="margin-left: 10px;margin-top: 10px"
                  v-if="discountTicket.ticketType === 2 || discountTicket.ticketType === 5"
            >
              <span style="font-size: 14px">折扣率:</span>
              <el-input-number v-model="discountTicket.rate" controls-position="right" size="mini"
                               :precision="2" :step="0.1"
                               @change="setRate" :min="1" :max="9.9"></el-input-number>
              折
              <br>
              <span style="color: #8c939d;margin-left: 10%;font-size: 12px">折扣范围1.1折至9.9折。例：设置2折后，原价10元，用户仅需付2元</span>
            </div>
            <div style="margin-left: 10px;margin-top: 10px" v-if="discountTicket.ticketType === 7">
              <span style="font-size: 14px">礼品名称:</span>
              <el-input v-model="discountTicket.consumptionName" placeholder="请填写兑换的产品或服务"
                        size="mini" style="width: 40%;"
              ></el-input>
              <el-button style="font-size: 14px" size="mini" @click="showConsumptionDialog">选择产品或服务</el-button>
            </div>
            <div style="margin-left: 10px;margin-top: 10px" v-if="discountTicket.ticketType > 3 && discountTicket.ticketType < 7">
              <span style="font-size: 14px">产品和服务:</span>
              <el-input v-model="discountTicket.consumptionName" readonly size="mini" style="width: 40%;"
              ></el-input>
              <el-button size="mini" @click="showConsumptionDialog">选择产品或服务</el-button>
            </div>
            <div style="margin-left: 10px;margin-top: 10px">
              <span style="font-size: 14px">可适用门店:</span>
              <el-link type="primary">已选择{{selectedShops.length}}家适用门店</el-link>
              <el-button size="mini" @click="showShopDialog">选择门店</el-button>
            </div>
            <div style="margin-left: 10px;margin-top: 10px">
              <span style="font-size: 14px">代金券有效期:</span>
              <el-date-picker
                v-model="discountTicket.validDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                size="mini">
              </el-date-picker>
            </div>
            <div style="margin-left: 10px;margin-top: 10px">
              <span style="font-size: 14px">小程序是否可见:</span>
              <el-radio-group v-model="discountTicket.miniShow">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>
            <div style="margin-left: 10px;margin-top: 10px">
              <span style="font-size: 14px">领取次数:</span>
              <el-input v-model="discountTicket.getNum" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
            </div>
            <div style="margin-left: 10px;margin-top: 10px">
              <span style="font-size: 14px">优惠券总张数:</span>
              <el-input v-model="discountTicket.totalNum" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
            </div>
            <el-divider class="line"></el-divider>
            <el-button size="mini" @click="createTicket">创建优惠券</el-button>
          </div>
        </div>
      </el-card>
    </div>

    <el-dialog
      title="产品和服务"
      :visible.sync="consumptionVisible"
      width="70%"
      @close="closeConsumptionDialog"
      :close-on-click-modal="false"
    >
    <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div class="between" style="padding: 0 10px">
        <div class="left_con" >
          <div class="left_inner_con">
            <el-card>
              <el-tree
                :data="consumptionTypeList"
                :props="consumptionTypeProps"
                @node-click="consumptionTypeHandleNodeClick"
                :highlight-current="true"
                node-key="id"
                :filter-node-method="consumptionTypeFilterNode"
                default-expand-all
                ref="serviceTree"
              >
              </el-tree>
            </el-card>
          </div>
        </div>
        <div class="table_container" style="margin: 10px 0">
          <el-card class="box-card">
            <el-table :data="consumptionList" fit border stripe="stripe"
                      height="550px" :cell-style="{padding: '5px'}"
                      :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                      :row-style="{height: '0'}">
              <el-table-column
                align="center"
                label="操作" width="160">
                <template slot-scope="scope">
                    <el-radio :label="scope.$index" v-model="consumptionIndex"  @change.native="selectConsumption(scope.row)">{{''}}</el-radio>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="consumptionName"
                label="服务名称" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="price"
                label="标准价格" >
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="选择适用门店"
      :visible.sync="shopVisible"
      width="50%"
      @close="closeShopDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style=" height: 400px;display: flex;justify-items: center;justify-content: center">
        <el-transfer
          filterable ref="shopTransfer"
          :filter-method="filterMethod"
          filter-placeholder="请输入门店名称"
          style="height: 400px;" size="mini" :props="{key:'id', label:'orgName'}"
          v-model="selectedShops" :titles="['待选择门店','已选择门店']"
          :button-texts="['移除', '添加']"
          :data="shopList" @change="handleChange" clearQuery>
        </el-transfer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeShopDialog">取 消</el-button>
        <el-button size="mini" @click="selectionShop">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      shopId:'',
      userId:'',
      orgLevel:'',
      radio:0,
      discountTicket:{
        //标题
        title:'',
        //副标题
        fuTitle:'',
        //类别
        ticketType:1,
        ticketTypeName:'',
        //代金金额
        money:'',
        //满金额
        fullMoney:'',
        //减金额
        subMoney:'',
        //有效期
        validDate:'',
        //折扣率
        rate:'',
        //单品名称
        consumptionName:'',
        //适用门店
        shopIds:[],
        creator:'',
        miniShow:1,
        getNum:'',
        totalNum:''
      },
      ticketTypes:[
        {value:1, label:'全场代金券'},
        {value:2, label:'全场折扣券'},
        {value:3, label:'全场满减券'},
        {value:4, label:'单品代金券'},
        {value:5, label:'单品折扣券'},
        {value:6, label:'单品特价券'},
        {value:7, label:'礼品兑换券'}
      ],
      //全场代金
      dJTicket:{title:'全场代金券',fuTitle:'请到店后使用'},
      //全场折扣
      zkTicket:{title:'折全场优惠券',fuTitle:'请到店后使用'},
      //满减
      mJTicket:{title:'全场满减券',fullTitle:'满',subTitle:'减',lastTitle:'券',fuTitle:'请到店后使用'},
      //单品代金
      dPdJTicket:{title:'单品代金券',fuTitle:'请到店后使用'},
      //单品折扣
      dPzkTicket:{title:'折单品优惠券',fuTitle:'请到店后使用'},
      //单品折扣
      dPTjTicket:{title:'单品特价券',fuTitle:'请到店后使用'},
      //兑换
      dHTicket:{title:'兑换券',fuTitle:'请到店后使用'},
      consumptionVisible:false,
      consumptionTypeList:[],
      consumptionTypeProps:{       //消费项目树展示信息
        label: 'consumptionTypeName',
        children: 'children'
      },
      consumptionIndex:'',
      consumptionList:[],
      selectedConsumption:'',
      consumptionRequest:{
        orgId:'',
        typeId:'',
        dateType:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        consumptionId:''
      },
      baseRequest:{
        orgId:'',
        orgLevel:''
      },
      checkResult:false,
      shops:[],
      shopList:[],
      shopVisible:false,
      selectedShops:[],

    }
  },
  methods:{
    //设置折扣
    setRate(){
      if (this.discountTicket.ticketType === 5){
        this.discountTicket.title = this.discountTicket.rate + this.dPzkTicket.title;
      } else {
        this.discountTicket.title = this.discountTicket.rate + this.zkTicket.title;
      }
    },
    clearTicket(){
      this.discountTicket.validDate='';
      this.discountTicket.money = '';
      this.discountTicket.consumptionName ='';
      this.discountTicket.rate = '';
      this.discountTicket.fullMoney = '';
      this.discountTicket.subMoney = '';
    },
    //选择优惠券分类
    selectTicketType(){
      this.clearTicket();
      switch (this.discountTicket.ticketType){
        case 1:
          this.discountTicket.title = this.dJTicket.title;
          this.discountTicket.fuTitle = this.dJTicket.fuTitle;
          this.discountTicket.ticketTypeName = '全场代金券';
          break;
        case 2:
          this.discountTicket.rate = 1;
          this.setRate();
          this.discountTicket.fuTitle = this.zkTicket.fuTitle;
          this.discountTicket.ticketTypeName = '全场折扣券';
          break;
        case 3:
          this.discountTicket.title = this.mJTicket.title;
          this.discountTicket.fuTitle = this.mJTicket.fuTitle;
          this.discountTicket.ticketTypeName = '全场满减券';
          break;
        case 4:
          this.discountTicket.title = this.dPdJTicket.title;
          this.discountTicket.fuTitle = this.dJTicket.fuTitle;
          this.discountTicket.ticketTypeName = '单品代金券';
          break;
        case 5:
          this.discountTicket.rate = 1;
          this.setRate();
          this.discountTicket.fuTitle = this.zkTicket.fuTitle;
          this.discountTicket.ticketTypeName = '单品折扣券';
          break;
        case 6:
          this.discountTicket.title = this.dPTjTicket.title;
          this.discountTicket.fuTitle = this.zkTicket.fuTitle;
          this.discountTicket.ticketTypeName = '单品特价券';
          break;
        case 7:
          this.discountTicket.title = this.dHTicket.title;
          this.discountTicket.fuTitle = this.dHTicket.fuTitle;
          this.discountTicket.ticketTypeName = '礼品兑换券';
          break;
      }
    },
    //设置代金额
    setDMoney(){
      if (this.discountTicket.money === ''){
        this.discountTicket.title = this.dJTicket.title;
      }
      if (this.discountTicket.ticketType === 1){
        this.discountTicket.title = this.discountTicket.money + '元' + this.dJTicket.title;
      }
      if(this.discountTicket.ticketType === 4){
        this.discountTicket.title = this.discountTicket.money + '元' + this.dPdJTicket.title;
      }
      if(this.discountTicket.ticketType === 6){
        this.discountTicket.title = this.discountTicket.money + '元' + this.dPTjTicket.title;
      }
    },
    //设置满减
    setFullMoney(){
      if (this.discountTicket.fullMoney === ''){
        this.discountTicket.title = this.mJTicket.title;
      } else {
        this.discountTicket.title = this.mJTicket.fullTitle + this.discountTicket.fullMoney + '元'
          + this.mJTicket.subTitle + this.discountTicket.subMoney +'元' + this.mJTicket.lastTitle;
      }
    },
    closeConsumptionDialog(){
      this.consumptionVisible = false;
    },
    showConsumptionDialog(){
      this.loadConsumptionType();
      this.consumptionVisible = true;
    },
    async consumptionTypeHandleNodeClick(data){
      this.dataType = data.type;
      if (data.consumptionTypeName === '服务分类'){
        this.dataType = 1;
      }
      if (data.consumptionTypeName === '产品分类'){
        this.dataType = 2;
      }
      this.consumptionTypeId = data.consumptionTypeId;
      await this.loadConsumption();
    },
    consumptionTypeFilterNode(value, data) {
      if (!value) return true;
      return data.consumptionTypeName.indexOf(value) !== -1;
    },
    selectConsumption(data){
      this.selectedConsumption = data;
      this.discountTicket.consumptionName = data.consumptionName;
      this.closeConsumptionDialog();
    },
    loadConsumption(){
      this.consumptionRequest.dateType = this.dataType;
      this.consumptionRequest.typeId = this.consumptionTypeId;
      this.consumptionRequest.orgId = this.shopId
      this.consumptionRequest.pageNum = 1;
      this.consumptionRequest.pageSize = 1000;
      this.loadConsumptionList();
    },
    async loadConsumptionList(){
      const {data:res} = await this.$http.post(`/load/list/consumption`, this.consumptionRequest)
      this.consumptionList = res.data;
    },
    async loadConsumptionType(){
      const {data:res} = await this.$http.get(`/discount/ticket/consumptionType/orgId/${this.shopId}`)
      this.consumptionTypeList = res.data;
    },
    async createTicket(){
      this.commonCheck();
      if (this.checkResult){
        return;
      }
      switch (this.discountTicket.ticketType){
        case 1:
          this.dJTicketCheck();
          break;
        case 2:
          this.zKTicketCheck();
          break;
        case 3:
          this.mJTicketCheck();
          break;
        case 4:
          this.dJTicketCheck();
          break;
        case 5:
          this.zKTicketCheck();
          break;
        case 6:
          this.tJTicketCheck();
          break;
        case 7:
          this.dHTicketCheck();
          break;
      }
      if (this.selectedShops.length === 0){
        return this.$message.warning("请选择适用门店");
      }
      if (this.checkResult){

      } else {
        this.discountTicket.shopIds = this.selectedShops;
        this.discountTicket.creator = this.userId;
        const {data:res} = await this.$http.post(`/new/ticket`, this.discountTicket)
        await this.$router.push("/discountTickets");
      }
    },
    commonCheck(){
      if (this.discountTicket.title === ''){
        this.checkResult = true;
        return this.$message.warning("标题不能为空！");
      }
      if (this.discountTicket.fuTitle === ''){
        this.checkResult = true;
        return this.$message.warning("副标题不能为空！");
      }
      if (this.discountTicket.validDate === ''){
        this.checkResult = true;
        return this.$message.warning("截止有效期不能为空！");
      }
      this.checkResult = false;
    },
    dJTicketCheck(){
      if (this.discountTicket.money === '' || this.discountTicket.money === 0){
        this.checkResult = true;
        return this.$message.warning("代金券面额必须是大于0的数！");
      }
      if (this.discountTicket.ticketType === 4 && this.discountTicket.consumptionName === ''){
        this.checkResult = true;
        return this.$message.warning("请选择产品和服务！");
      }
      this.checkResult = false;
    },
    mJTicketCheck(){
      if (this.discountTicket.fullMoney === '' || this.discountTicket.fullMoney === 0){
        this.checkResult = true;
        return this.$message.warning("请输入消费满金额！");
      }
      if (this.discountTicket.subMoney === '' || this.discountTicket.subMoney === 0){
        this.checkResult = true;
        return this.$message.warning("请输入消费减金额！");
      }
      this.checkResult = false;
    },
    zKTicketCheck(){
      if (this.discountTicket.rate === '' || this.discountTicket.rate === 0){
        this.checkResult = true;
        return this.$message.warning("请输入折扣率！");
      }
      if (this.discountTicket.ticketType === 5 && this.discountTicket.consumptionName === ''){
        this.checkResult = true;
        return this.$message.warning("请选择产品和服务！");
      }
      this.checkResult = false;
    },
    dHTicketCheck(){
      if (this.discountTicket.consumptionName === ''){
        this.checkResult = true;
        return this.$message.warning("请选择兑换礼品！");
      }
      this.checkResult = false;
    },
    tJTicketCheck(){
      if (this.discountTicket.consumptionName === ''){
        return this.$message.warning("请选择产品和服务！");
      }
      this.checkResult = false;
    },
    showShopDialog(){
      this.loadShops();
      this.$nextTick(() => {
        this.$refs.shopTransfer.clearQuery('left')
        this.$refs.shopTransfer.clearQuery('right')
      })
      this.shopVisible = true;
    },
    closeShopDialog(){
      this.shopVisible = false;
    },
    async loadShops(){
      this.baseRequest.shopId = this.shopId;
      this.baseRequest.orgLevel = this.orgLevel;
      this.shopList = [];
      this.selectedShops = [];
      const {data:res} = await this.$http.post(`/load/shops`, this.baseRequest)
      this.shopList = res.data;
    },
    filterMethod(query, item){
      return item.orgName.indexOf(query) > -1;
    },
    selectionShop(){
      this.closeShopDialog();
    },
    handleChange(value, direction, movedKeys){
      this.selectedShops = value;
    }
  },
  created(){
    this.shopId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.selectTicketType();
  }
}
</script>

<style scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
  background-color: #eff3f8;
}
.cardStyle{
  width: 98%;
}
.ticketStyle{
  width: 30%;
  height: 500px;
  border-radius: 5px;
  background-color: #49846a;
}
.fontStyle{
  display: block;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color: #8d8d8d;
}
.card_name{
  font-weight: normal;
  font-size: 22px;
  word-break: break-word;
  word-wrap: break-word;
  margin-bottom: 5px;
  color: #333;
  width: 100%;
}
.cardTips{
  color: #000;
  font-size: 12px;
  margin-bottom: 15px;
  width: 100%
}
.line{
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  width: auto;
  margin: 10px 0;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AddDiscountTicket.vue